import { render, staticRenderFns } from "./ContingentNewItem.vue?vue&type=template&id=2c536e64&scoped=true&"
import script from "./ContingentNewItem.vue?vue&type=script&lang=js&"
export * from "./ContingentNewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c536e64",
  null
  
)

export default component.exports